"use client";
import React, { Ref, useEffect, useRef, useState } from "react";
import { Popover } from "antd";
import { IoCloseSharp } from "react-icons/io5";
import { useRouter } from "next/navigation";
import { useAuth } from "@/hooks";
import reactionAPI from "@/services/reaction_api";
import { SwitchEmoji } from "@/layouts/styles/ssr.style";
import ChaptersList from "@/modules/book-body/components/chapter-list";
import { AiOutlineWechat } from "react-icons/ai";
import { GiHamburgerMenu } from "react-icons/gi";
import { BsArrowLeft } from "react-icons/bs";
import { ResponseTypes } from "@/types/constants";
import { definitions } from "@/services/metruyenvl";
import Image from "next/image";
import { MdDisplaySettings } from "react-icons/md";
import DisplaySetting from "./setting-display";
import { userActionAPI } from "@/services/user_action_api";
import { useDispatch } from "react-redux";
import { Dispatch } from "@reduxjs/toolkit";
import { showModalForm } from "@/redux/reducers/user.reducer";

type scrollComment = () => void;

type IHover = {
    hoverChapters: boolean;
    hoverSettings: boolean;
    hoverReaction: boolean;
};

function NavRightDetail({ book, chapter, bgColor, scrollComment }: { book: definitions["do.BookDO"]; chapter: definitions["do.ChapterContentRes"]; bgColor: string; scrollComment?: scrollComment }) {
    const [react, setReact] = useState<boolean>(false);
    const dispatch = useDispatch<Dispatch>();
    const [showChapter, setShowChapter] = useState<boolean>(false);
    const [showSettings, setShowSettings] = useState<boolean>(false);
    const [hovered, setHovered] = useState<IHover>({
        hoverChapters: false,
        hoverSettings: false,
        hoverReaction: false,
    });
    const ref: any = useRef(null);
    const [statusLike, setStatusLike] = useState<string>("like");
    const router = useRouter();
    const { isAuth } = useAuth();

    const getStatusReact = async () => {
        try {
            const res: ResponseTypes = await userActionAPI.getUserAction("chapter", chapter.id ?? "");
            let action: definitions["do.UserActionDO"] = res.data;
            setStatusLike(action.reaction_used ?? "like");
            // console.log(chapter);
        } catch (error) {
            console.log(error);
        }
    };

    const postLike = async (type: definitions["models.ReactionType"]) => {
        if (isAuth) {
            try {
                const res = await reactionAPI.postReaction("chapter", chapter.id as string, type);
                setStatusLike(type);
                setReact(false);
            } catch (error) {
                console.log(error);
            }
        } else {
            dispatch(showModalForm(true));
        }
    };

    const handleEscKey = (e: KeyboardEvent) => {
        if (e.key === "Escape") {
            setShowChapter(false);
            setShowSettings(false);
        }
    };

    const [isFix, setFix] = useState(false);
    const [leftPosition, setLeftPosition] = useState(0);

    useEffect(() => {
        if (isAuth) {
            getStatusReact();
        }
        if (typeof document !== "undefined") {
            const handleScroll = () => {
                const parentBox = document.getElementById("chapterContent");
                const offsetTop = parentBox?.getBoundingClientRect().top || 0;
                setFix(offsetTop < 0);
                setLeftPosition(11 + (parentBox?.getBoundingClientRect().left || 0) + (parentBox?.getBoundingClientRect().width || 0));
            };

            // Thêm lắng nghe sự kiện cuộn
            window.addEventListener("scroll", handleScroll);

            // Loại bỏ lắng nghe khi component unmount
            document.addEventListener("keydown", handleEscKey);
            return () => {
                window.removeEventListener("scroll", handleScroll);
                document.removeEventListener("keydown", handleEscKey);
            };
        }
    }, []);
    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setReact(false);
                setShowSettings(false);
                setShowChapter(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
    const iconSize = 55;
    const handleHoverChange = (open: boolean, t: string) => {
        setHovered({ ...hovered, [t]: open });
    };
    return (
        <div style={{ backgroundColor: bgColor, left: leftPosition + "px" }} className={"rounded-lg w-20" + (isFix ? " fixed top-4" : "")}>
            <Popover
                content="Danh sách chương"
                placement="right"
                trigger="hover"
                open={hovered.hoverChapters}
                onOpenChange={(e: boolean) => {
                    handleHoverChange(e, "hoverChapters");
                }}
            >
                <div className="relative p-4 hover:cursor-pointer hover:bg-white rounded-t-lg flex items-center justify-center">
                    <div
                        className="w-full h-full flex items-center justify-center"
                        onClick={() => {
                            setShowChapter(!showChapter);
                            setShowSettings(false);
                            setReact(false);
                        }}
                    >
                        <GiHamburgerMenu size={26} color="#333333" />
                    </div>
                    {showChapter && (
                        <div className="absolute bg-white p-4 right-20 top-0 rounded-lg overflow-y-scroll h-[600px]" style={{ width: "1000px", zIndex: 1000 }}>
                            <IoCloseSharp
                                className="float-right cursor-pointer"
                                size={24}
                                onClick={() => {
                                    setShowChapter(false);
                                    setHovered({
                                        hoverChapters: false,
                                        hoverReaction: false,
                                        hoverSettings: false,
                                    });
                                }}
                            />
                            <ChaptersList slug={book?.slug as string} />
                        </div>
                    )}
                </div>
            </Popover>
            <Popover
                content="Cài đặt hiển thị"
                placement="right"
                open={hovered.hoverSettings}
                onOpenChange={(e: boolean) => {
                    handleHoverChange(e, "hoverSettings");
                }}
            >
                <div
                    className="relative p-4 hover:cursor-pointer hover:bg-white flex items-center justify-center"
                    onClick={() => {
                        setShowChapter(false);
                        setReact(false);
                        setShowSettings(!showSettings);
                    }}
                >
                    <MdDisplaySettings size={26} color="#333333" />
                </div>
                {showSettings && (
                    <div className="absolute bg-white p-4 right-[106px] top-14 rounded-lg" style={{ minWidth: "500px", zIndex: 100 }}>
                        <IoCloseSharp
                            className="float-right cursor-pointer"
                            size={24}
                            onClick={() => {
                                setShowSettings(false);
                                setHovered({
                                    hoverChapters: false,
                                    hoverReaction: false,
                                    hoverSettings: false,
                                });
                            }}
                        />
                        <DisplaySetting
                            slug={book.slug as string}
                            onClose={() => {
                                setShowSettings(false);
                                setHovered({
                                    hoverChapters: false,
                                    hoverReaction: false,
                                    hoverSettings: false,
                                });
                            }}
                        />
                    </div>
                )}
            </Popover>
            <Popover content="Thông tin truyện" placement="right">
                <div
                    className="relative p-4 hover:cursor-pointer hover:bg-white flex items-center justify-center"
                    onClick={() => {
                        router.push(`/truyen/${book.slug}`);
                    }}
                >
                    <BsArrowLeft size={26} color="#333333" />
                </div>
            </Popover>
            <div className="relative p-4 hover:cursor-pointer hover:bg-white rounded-b-lg flex items-center justify-center" onClick={scrollComment}>
                <AiOutlineWechat size={26} color="#333333" />
            </div>

            <div
                className="relative p-4 hover:cursor-pointer hover:bg-white flex items-center justify-center"
                onClick={() => {
                    setReact(!react);
                    setShowChapter(false);
                    setShowSettings(false);
                }}
            >
                <SwitchEmoji type={statusLike} />
            </div>
            {react && (
                <div
                    ref={ref}
                    // onClick={() => {
                    //     setReact(false);
                    // }}
                    className="absolute top-0 right-[110px] bg-white w-full h-auto flex flex-col items-center gap-y-2 p-3 rounded-xl"
                >
                    {" "}
                    <Image
                        onClick={() => {
                            postLike("like");
                        }}
                        unoptimized={true}
                        width={iconSize}
                        height={iconSize}
                        className="reactButton ease-in duration-75 hover:scale-150"
                        src="/like.gif"
                        alt="Like emoji"
                        style={{ minWidth: { iconSize } + "px" }}
                    />
                    <Image
                        onClick={() => {
                            postLike("love");
                        }}
                        unoptimized={true}
                        width={iconSize}
                        height={iconSize}
                        className="reactButton ease-in duration-75 hover:scale-150"
                        src="/love.gif"
                        alt="Love emoji"
                        style={{ minWidth: { iconSize } + "px" }}
                    />
                    <Image
                        onClick={() => {
                            postLike("lol");
                        }}
                        unoptimized={true}
                        width={iconSize}
                        height={iconSize}
                        className="reactButton ease-in duration-75 hover:scale-150"
                        src="/haha.gif"
                        alt="Haha emoji"
                        style={{ minWidth: { iconSize } + "px" }}
                    />
                    <Image
                        onClick={() => {
                            postLike("wow");
                        }}
                        unoptimized={true}
                        width={iconSize}
                        height={iconSize}
                        className="reactButton ease-in duration-75 hover:scale-150"
                        src="/wow.gif"
                        alt="Wow emoji"
                        style={{ minWidth: { iconSize } + "px" }}
                    />
                    <Image
                        onClick={() => {
                            postLike("sad");
                        }}
                        unoptimized={true}
                        width={iconSize}
                        height={iconSize}
                        className="reactButton ease-in duration-75 hover:scale-150"
                        src="/sad.gif"
                        alt="Sad emoji"
                        style={{ minWidth: { iconSize } + "px" }}
                    />
                    <Image
                        onClick={() => {
                            postLike("angry");
                        }}
                        unoptimized={true}
                        width={iconSize}
                        height={iconSize}
                        className="reactButton ease-in duration-75 hover:scale-150"
                        src="/angry.gif"
                        alt="Angry emoji"
                        style={{ minWidth: { iconSize } + "px" }}
                    />
                </div>
            )}
        </div>
    );
}

export default NavRightDetail;
